import React, { useState, useEffect } from "react";
import Axios from "axios";
import { useHistory } from "react-router-dom";

const Player = ({ playerId }) => {
  const API_KEY = "h9vIRJ3BX4giPnYrzznPD758zs03";
  const [data, setData] = useState("");

  let history = useHistory();

  useEffect(() => {
    Axios.get(
      `https://cricapi.com/api/playerStats?apikey=${API_KEY}&pid=${playerId}`
    ).then((res) => {
      setData(res.data);
    });
  }, []);

  const handleGoBack = () => {
    history.push("/");
  };

  return (
    <div>
      <div className="goBackBtnDiv">
        <button onClick={handleGoBack} className="goBackBtn">
          Go Back
        </button>
      </div>
      <div className="infoContainer">
        <img src={data.imageURL} alt="profileImage" className="imgDiv" />
        <h1 className="playerName">{data.name}</h1>
        <div className="pInfo">Country: {data.country}</div>
        <div className="pInfo">Playing Role: {data.playingRole}</div>
        <div className="pInfo">Age: {data.currentAge}</div>
        <div className="pInfo">Batting Style: {data.battingStyle}</div>
        <div className="pInfo">Bowling Style: {data.bowlingStyle}</div>
        <div className="pProfile">{data.profile}</div>
      </div>
    </div>
  );
};

export default Player;
